export default __webpack_public_path__ + "static/media/14.10aa9c9f.mp4";